import React, { PureComponent } from 'react';
import cookie from 'cookie';
import config from 'config';

const TYPES = [
  { type: 'engaged', regexps: [/^\/\w{2}\/detail\/.*/i] },
  { type: 'lead', regexps: [/.*/] }
];

export default class TravelPayoutPixel extends PureComponent {
  getType(pathname) {
    if (!pathname) {return;}

    for (let type of TYPES) {
      for (let regexp of type.regexps) {

        if (regexp.test(pathname)) {
          return type.type;
        }
      }
    }
  }

  render() {
    const { pathname } = this.props;
    const type = this.getType(pathname);

    if (!type) {return null;}

    return (
      <img
        src={`https://${config.TRAVEL_PAYOUTS_HOSTNAME}/pixel.png?type=${type}`}
        height="1"
        width="1"
        alt=""
      />
    );
  }
}

export function setTravelPayoutsCookie(subId) {
  if (!subId) {return;}

  if (process.env.REACT_APP_IS_CLIENT) {
    document.cookie = cookie.serialize('travel_payouts_sub_id', String(subId), {
      path: '/',
      httpOnly: false,
      maxAge: 60 * 60 * 24 * 30 // 30 days
    });
  }
}

export function getTravelPayoutsSubId() {
  if (process.env.REACT_APP_IS_CLIENT) {
    const cookies = cookie.parse(document.cookie || '');

    return cookies.travel_payouts_sub_id || null;
  }
}



// WEBPACK FOOTER //
// ./src/widgets/TravelPayouts/index.js